import React, { FC, useCallback } from 'react'

import { createPortal } from 'react-dom'

import useToggle from 'Hooks/useToggle'

import ForgotPasswordModal from 'Components/CustomerFieldsGroup/ForgotPasswordModal'
import PasswordField from 'Components/CustomerFieldsGroup/PasswordField'

export const Password: FC = () => {
  const [forgotPasswordModalVisibility, , openForgotPasswordModal, closeForgotPasswordModal] = useToggle()

  const handleForgotPasswordClick = useCallback(() => {
    openForgotPasswordModal()
  }, [openForgotPasswordModal])

  return (
    <div>
      <PasswordField
        required
        autoComplete="current-password"
        label="Password"
        wrapperClassName="user-profile-login__field-group user-profile-field"
      />

      <button className="user-profile-link-button mt-2" type="button" onClick={handleForgotPasswordClick}>
        Forgot your password?
      </button>
      <div>
        {forgotPasswordModalVisibility
          ? createPortal(<ForgotPasswordModal closeModal={closeForgotPasswordModal} />, document.body)
          : null}
      </div>
    </div>
  )
}
